import { state_isItemsDataLoaded } from "../../state/state_isItemDataLoaded";
import { state_items } from "../../state/state_items";

export async function loadEmptyData() {
  console.log("load:loadEmptyData");
  await state_items.setItemsBulk([]);
  state_isItemsDataLoaded.set(true);
}
